import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@/components';
export const withTooltip = (title, visible, jsx) => {
    if (visible) {
        return (_jsx(Tooltip, { placement: 'top', title: title, children: jsx }));
    }
    return jsx;
};
